
import Vue from 'vue';
export default Vue.extend({
  name: 'owc-header-logo',
  props: {
    homePageLinkObject: {
      type: Object,
      required: false,
    },
  },
  computed: {
    homePageLink() {
      let url = '/';
      let target = '_self';
      let aria = '';

      if (this.homePageLinkObject) {
        url = this.homePageLinkObject.url;
        target = this.homePageLinkObject.target;
        aria = this.homePageLinkObject.aria;
      }

      return { url, target, aria };
    },
  },
});
